import React from 'react'
import { Link } from 'react-router'
import { formatDateYYYYMMDD } from '../../../../packages/utils/numberFormatters'
import { getUrlForType } from '../../../../utils/getUrlForEntity'
import { HasWarrantLabel, KVLabel } from '../../../../components/entities/IssueTypeLabels'
import { RelatedTransaction } from '@finance-lab/utils/types'
import List from '@mui/material/List'
import ListSubheader from '@mui/material/ListSubheader'
import ListItem from '@mui/material/ListItem'
import Stack from '@mui/material/Stack'
import { issueTags, SearchOption } from '../../../../components/Autocomplete'

const dateBasedOnType = (option: Extract<SearchOption, { entityType: 'Issue' }>) => {
    if (option.issueType === 'Rights issue') {
        return option.subEndDate
    } else {
        return option.publicationDate
    }
}

export const RelatedTransactions = ({ transactions }: { transactions: RelatedTransaction[] }) => {
    if (transactions.length === 0) return null

    return (
        <List subheader={<ListSubheader sx={{ paddingLeft: 0 }}>Relaterade transaktioner</ListSubheader>}>
            {transactions
                .map((t) => ({ ...t, url: getUrlForType(t) }))
                .map((t) => {
                    if (t.entityType === 'Issue') {
                        const numberOfWarrants =
                            t.numWarrants === null || t.numWarrants === undefined ? null : t.numWarrants
                        return (
                            <ListItem key={t.id} sx={{ paddingLeft: 0 }}>
                                <div tabIndex={0} style={{ marginLeft: '0px' }}>
                                    <Stack
                                        direction='row'
                                        spacing={2}
                                        sx={{
                                            alignItems: 'center',
                                            display: 'flex',
                                        }}
                                    >
                                        <Stack
                                            direction='row'
                                            spacing={2}
                                            sx={{
                                                alignItems: 'center',
                                                display: 'flex',
                                            }}
                                        >
                                            {issueTags({
                                                ...t,
                                                hasWarrants: !!numberOfWarrants,
                                                spac: null,
                                                rto: null,
                                            })}
                                        </Stack>
                                        <Link to={t.url ?? ''}>{t.instrumentName}</Link>
                                        <span>{formatDateYYYYMMDD(dateBasedOnType(t))}</span>
                                    </Stack>
                                </div>
                            </ListItem>
                        )
                    }

                    if (t.entityType === 'Warrant') {
                        return (
                            <ListItem key={t.id} sx={{ paddingLeft: 0 }}>
                                <div tabIndex={0} style={{ marginLeft: '0px' }}>
                                    <Stack
                                        direction='row'
                                        spacing={2}
                                        sx={{
                                            alignItems: 'center',
                                            display: 'flex',
                                        }}
                                    >
                                        <HasWarrantLabel key='TO' /> <Link to={t.url ?? ''}>{t.name}</Link>
                                        <span>{formatDateYYYYMMDD(t.subEndDate)}</span>
                                    </Stack>
                                </div>
                            </ListItem>
                        )
                    }

                    if (t.entityType === 'Convertible') {
                        return (
                            <ListItem key={t.id} sx={{ paddingLeft: 0 }}>
                                <div tabIndex={0} style={{ marginLeft: '0px' }}>
                                    <Stack
                                        direction='row'
                                        spacing={2}
                                        sx={{
                                            alignItems: 'center',
                                            display: 'flex',
                                        }}
                                    >
                                        <KVLabel />
                                        <Link to={t.url ?? ''}>{t.name}</Link>
                                    </Stack>
                                </div>
                            </ListItem>
                        )
                    }
                })}
        </List>
    )
}
